'use client';

import ComposerHeaderSkeleton from '@/common/ComposerHeaderSkeleton';
import SpaNavigationSkeletonOverlay from '@/common/SpaNavigationSkeletonOverlay';
// eslint-disable-next-line local-rules/page-boundary-imports -- the SRP skeleton is shown from Home's SPA navigation to SRP
import SearchResultsLoadingSkeleton from '@/srp/SearchResultsLoadingSkeleton';
import {
  useDismissSrpNavigation,
  useSrpSkeletonProps
} from '~/context/common/SrpNavigationContext';

type OwnProps = {
  mainContentId: string;
};

export default function SrpSkeletonOverlay({ mainContentId }: OwnProps) {
  const srpSkeletonProps = useSrpSkeletonProps();
  const dismissSrpNavigation = useDismissSrpNavigation();

  if (!srpSkeletonProps) return null;

  return (
    <SpaNavigationSkeletonOverlay
      durationEventName="srp-skeleton-duration"
      header={
        srpSkeletonProps.shouldShowComposer ? (
          <ComposerHeaderSkeleton route="/cars" />
        ) : undefined
      }
      mainContentId={mainContentId}
      onDismiss={dismissSrpNavigation}
    >
      <SearchResultsLoadingSkeleton {...srpSkeletonProps} />
    </SpaNavigationSkeletonOverlay>
  );
}
